import type { EditPlayerFormValues } from '../../types'
import {
  ADMIN_FIELD_TO_BE_KEY,
  PLAYER_DETAILS_FIELD_SECTIONS,
  PLAYER_DETAILS_TABLE_SECTIONS,
} from '../constants'
import type {
  PlayerDetailsAdminField,
  PlayerDetailsField,
  PlayerDetailsFieldSectionKey,
  PlayerDetailsSectionKey,
} from '../types'

/**
 * Narrows a section key to the sections that hold editable fields. Takes any
 * string so the shared section-edit context's plain keys can be narrowed too.
 */
export const isFieldSectionKey = (
  key: string
): key is PlayerDetailsFieldSectionKey =>
  Object.prototype.hasOwnProperty.call(PLAYER_DETAILS_FIELD_SECTIONS, key)

/** A section's title, whichever kind it is. */
export const getSectionLabel = (key: PlayerDetailsSectionKey): string =>
  isFieldSectionKey(key)
    ? PLAYER_DETAILS_FIELD_SECTIONS[key].label
    : PLAYER_DETAILS_TABLE_SECTIONS[key].label

export const isAdminField = (
  field: PlayerDetailsField
): field is PlayerDetailsAdminField =>
  Object.prototype.hasOwnProperty.call(ADMIN_FIELD_TO_BE_KEY, field)

/**
 * Every form field a section edits, split by where its payload comes from.
 * Locked fields are display-only and excluded; the height pair expands to both
 * of its inputs.
 */
export const getSectionFields = (
  sectionKey: PlayerDetailsFieldSectionKey
): {
  profileFields: Array<keyof EditPlayerFormValues>
  adminFields: PlayerDetailsAdminField[]
} => {
  const profileFields: Array<keyof EditPlayerFormValues> = []
  const adminFields: PlayerDetailsAdminField[] = []

  PLAYER_DETAILS_FIELD_SECTIONS[sectionKey].fields.forEach((def) => {
    if (def.locked) {
      return
    }
    if (def.kind === 'height') {
      profileFields.push('heightFt', 'heightIn')
      return
    }
    if (isAdminField(def.name)) {
      adminFields.push(def.name)
    } else {
      profileFields.push(def.name)
    }
  })

  return { profileFields, adminFields }
}
